export const SEGMENTS = [
  { id: '1', name: 'Tipo de negócio', key: 'tipoNegocio' },
  { id: '2', name: 'Estado', key: 'estado' },
  { id: '3', name: 'Departamento', key: 'departamentos' },
  { id: '4', name: 'CNPJ', key: 'cnpj' },
];

export const SEGMENTS_SPONSORED_PRODUCTS = [
  { id: '1', name: 'Tipo de negócio', key: 'tipoNegocio' },
  { id: '2', name: 'Estado', key: 'estado' },
];
